import queryString from 'query-string';
import igniteToHubspotProductsMap from "./igniteToHubspotProductsMap";
import fields from './igniteToHubspotFieldNames.mjs';

export const hubspotEndpoints = {
  email: 'https://www.hancockwhitney.com/email-recommendations',
  customerPage: 'https://www.hancockwhitney.com/for-you',
  testActionPage: 'https://salesforce-hs-dev-5768121-5768121.hs-sites.com/test-action',
  formApi: 'https://api.hsforms.com/submissions/v3/integration/submit/1765103/09f4f9df-9dbd-4b9a-848e-ae2701016886',
  formApiTraining: 'https://api.hsforms.com/submissions/v3/integration/submit/22285381/3ad55046-513d-4e03-8041-c35fb23dd015',
};

export const buildHubspotEmailUrl = ({products, guideId}) => {
  const queryParams = {
    [fields.guideId]: guideId,
    ...getProductParamsObj({products, value: "Y"})
  };
  const result = buildUrlWithQuery(hubspotEndpoints.email, queryParams);
  console.log('Hubspot Url | Email Recommendations', result);
  return result;
};

export const buildHubspotCustomerPageUrl = ({products, guideId, runMode='', email=''}) => {
  const queryParams = {
    [fields.guideId]: guideId,
    [fields.email]: email,
    ...getProductParamsObj({
      products,
      value: "Y"
    })
  };
  const result = runMode.toLowerCase() === "pilot" || runMode.toLowerCase() === "staging" ?
    buildUrlWithQuery(hubspotEndpoints.testActionPage, queryParams) :
    buildUrlWithQuery(hubspotEndpoints.customerPage, queryParams);
  console.log('Hubspot Url | Customer Page', result);
  return result;
};

const getProductParamsObj = ({products=[], value="R", inclusive=true}) => {
  const result = {};
  const productIds = products.map(p => p.id.toString());
  Object.keys(igniteToHubspotProductsMap).map(productId => {
    const field = igniteToHubspotProductsMap[productId];
    const key = field.name.toLowerCase();
    if((inclusive && productIds.includes(productId)) ||
      (!inclusive && !productIds.includes(productId))) {
      result[key] = value
    }
  });
  return result;
};

const buildUrlWithQuery = (endpoint, queryParams) => {
  const query = queryString.stringify(queryParams, {arrayFormat: 'comma', encode: false});
  return `${endpoint}?${query}`;
};

export const canTriggerHubspotPostApi = (runMode='') => {
  //TODO: this should be based on environment before we go to live
  const parsed = queryString.parse(window.location.search);
  const {
    testingHubspot
  } = parsed;

  if(testingHubspot || runMode.toLowerCase() === "staging" || runMode.toLowerCase() === "pilot" || runMode.toLowerCase() === "production"){
    return true;
  }else{
    console.warn('Hubspot API call is not enabled');
  }
  return false;
};

